import { RecordContext } from '@powerportalspro/react';
import {
  BoolEdit,
  ChoiceEdit,
  Section,
  SectionColumn,
  TextEdit,
} from '@powerportalspro/react-fluent';

// `<RecordContext>` is invisible on its own — the sample renders it
// directly so the source tab shows the wrapper that loads & coordinates
// the record. Mirrors the Blazor `RecordContextMainDemo` which binds the
// demo's `ppp_democustomtable` (text / bool / choice columns).
//
// `warnOnUnsavedChanges={false}` keeps the docs page from prompting the
// browser-level "unsaved changes" warning while the user is just
// exploring the sample.
export function RecordContextMainSample() {
  return (
    <RecordContext table="ppp_democustomtable" warnOnUnsavedChanges={false}>
      <Section>
        <SectionColumn>
          <TextEdit columnName="ppp_name" />
          <BoolEdit columnName="ppp_credithold" />
          <ChoiceEdit columnName="ppp_favoritecolor" />
        </SectionColumn>
      </Section>
    </RecordContext>
  );
}
